import { jsx } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
function ColorHeaderPreview(props) {
  const { colors, modified } = props;
  return /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 0.5, children: colors.map((color, index) => /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        "&::after": modified?.[index] ? {
          background: "#000000",
          borderRadius: 50,
          bottom: "-36%",
          content: '""',
          height: "4px",
          position: "absolute",
          right: "50%",
          transform: "translateX(50%)",
          width: "4px"
        } : {},
        backgroundColor: color,
        border: "2px solid #c4c4c4",
        borderRadius: "8px",
        height: "24px",
        position: "relative",
        width: "24px"
      }
    },
    `${color}_${index}`
  )) });
}
export {
  ColorHeaderPreview
};
//# sourceMappingURL=ColorHeaderPreview.js.map
